import React from 'react';

import Poster from 'Core/Components/Poster';
import LogoBox from 'Core/Components/LogoBox';
import Headline from 'Core/Components/Headline';
import BlackBox from 'Core/Components/BlackBox';
import RoleList from 'Core/Components/RoleList';
import ContactList from 'Core/Components/ContactList';
import FilteredCardList from 'Site/Ui/FilteredCardList';

import Hero from 'Site/Ui/Hero';
import PostList from 'Site/Ui/PostList';
import CardList from 'Site/Ui/CardList';
import PhotoWall from 'Site/Ui/PhotoWall';
import ResponsiveVideo from 'Site/Ui/ResponsiveVideo';
import RecentBlogPosts from 'Site/Ui/RecentBlogPosts';

import Store from 'Site/State/Store';
import { getBlogPosts } from 'Site/State/Actions';

const ErrorStyle = {
  fontSize: '0.8em',
  overflow: 'auto',
  display: 'block',
  background: '#a85858',
  color: '#ebebeb',
  padding: '10px'
};

class ContentSectionController extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    let { props, type } = this.props;

    switch (type.toLowerCase()) {
      case 'html': return <div
        dangerouslySetInnerHTML={{ __html: props.content }}
        {...props}
      />;
      case 'article': return <article
        dangerouslySetInnerHTML={{ __html: props.content }}
        {...props}
      />;

      case 'postlist': return <PostList {...props} />;
      case 'hero': return <Hero {...props} />;
      case 'poster': return <Poster {...props} />;
      case 'logobox': return <LogoBox {...props} />;
      case 'blackbox': return <BlackBox {...props} />;
      case 'headline': return <Headline {...props} />;
      case 'rolelist': return <RoleList {...props} />;
      case 'cardlist': return <CardList {...props} />;
      case 'photowall': return <PhotoWall {...props} />;
      case 'contactlist': return <ContactList {...props} />;
      case 'recentblogposts': return <RecentBlogPosts {...props} getBlogPosts={getBlogPosts} store={Store} />;
      case 'responsivevideo': return <ResponsiveVideo {...props} />;
      case 'filteredcardlist': return <FilteredCardList {...props} />;

      default:
        console.error('No renderer:', { type, props });
        return (
          <pre style={ErrorStyle}>
            <code>
              <big>ContentSectionController Error:</big> {'\n'}
              <b>Element type "{type}" not found:</b> {'\n'}
              {JSON.stringify({ type, props }, null, '  ')}
            </code>
          </pre>
        );
    }
  }
};

export default ContentSectionController;



// WEBPACK FOOTER //
// ./client/Site/Controllers/ContentSectionController.jsx